// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a06af8ec","46":"93debc7c","284":"975b5dd7","443":"18dccac9","506":"00c60f40","834":"4d498cb9"}[chunkId] + ".chunk.js";
};